const state = {
  filterDate: Date.now(),
  currentTab: 0
}

export default state